<div *ngIf='groupIsVisible' class="cpri_container" (click)="showGroupEvents()">
    <div class="cpri_icon">
        <div [inlineSVG]="groupItem.icon"></div>
    </div>
    <div class="cpri_name_container">
        <div class="cpri_name">{{groupItem.name + ' '}}</div><div class="cpri_count">({{groupItem.events}})</div>
        <div class="cpri_arrow"><svg viewBox="0 0 8.402 14.697"><path d="M13.783,13.54l5.561-5.557A1.05,1.05,0,1,0,17.857,6.5l-6.3,6.3a1.048,1.048,0,0,0-.031,1.448l6.327,6.34A1.05,1.05,0,0,0,19.34,19.1Z" transform="translate(19.653 20.891) rotate(180)"/></svg></div>
    </div>
</div>
